/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AcademicProgramDocumentType model module.
 * @module model/AcademicProgramDocumentType
 * @version 1.0.0
 */
class AcademicProgramDocumentType {
    /**
     * Constructs a new <code>AcademicProgramDocumentType</code>.
     * AcademicProgram File documentation type
     * @alias module:model/AcademicProgramDocumentType
     * @param id {Number} 
     * @param name {String} 
     */
    constructor(id, name) { 
        
        AcademicProgramDocumentType.initialize(this, id, name);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, name) { 
        obj['id'] = id;
        obj['name'] = name;
    }

    /**
     * Constructs a <code>AcademicProgramDocumentType</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AcademicProgramDocumentType} obj Optional instance to populate.
     * @return {module:model/AcademicProgramDocumentType} The populated <code>AcademicProgramDocumentType</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AcademicProgramDocumentType();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('required')) {
                obj['required'] = ApiClient.convertToType(data['required'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
AcademicProgramDocumentType.prototype['id'] = undefined;

/**
 * @member {String} name
 */
AcademicProgramDocumentType.prototype['name'] = undefined;

/**
 * @member {Boolean} required
 */
AcademicProgramDocumentType.prototype['required'] = undefined;






export default AcademicProgramDocumentType;

